<template>
  <div class="timeline-wrap">
    <Loading
      type="line"
      :center="false"
      v-show="loading"
    />

    <div
      class="panel-header"
      v-if="!loading"
    >
      <b-row class="align-center">
        <b-col sm="10">
          <div class="title">
            <span class="product">{{ data.productName }}</span>
            <span class="sep">•</span>
            <span class="muted">Estoque</span>
            <span class="stock">{{ data.totalStock }}</span>
          </div>
        </b-col>
        <b-col sm="2">
          <div
            class="text-right"
            v-show="showButtonBack"
          >
            <Button
              _key="btnBackTimeLineAvailability"
              type="info"
              classIcon="fa-solid fa-arrow-left"
              size="small"
              eventName="btnBackTimeLineAvailability"
            />
          </div>
        </b-col>
      </b-row>
      <hr class="hr" />
    </div>

    <div v-if="!loading">
      <div class="div-legend">
        <div class="legend-chip">
          <span class="box-time dot-maintenance"></span>
          <span class="legend-text title">Manutenção</span>
        </div>
        <div class="legend-chip">
          <span class="box-time dot-rented"></span>
          <span class="legend-text title">Locado</span>
        </div>
        <div class="legend-chip">
          <span class="box-time dot-reserved"></span>
          <span class="legend-text title">Reservado</span>
        </div>
      </div>
    </div>

    <Gantt
      v-if="!loading"
      initialOption="Dia"
      :options="options"
      :tasks="data.tasks"
    />
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Gantt from "@nixweb/nixloc-ui/src/component/layout/Gantt";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import { mapMutations, mapState, mapActions } from "vuex";

export default {
  name: "TimeLineAvailability",
  props: { item: Object },
  components: { Button, Gantt, Loading },
  data() {
    return {
      urlGet: "/api/v1/stock/search-product/list-items-timeline",
      options: [
        { title: "Dia", eventName: "demoViewMode" },
        { title: "Semana", eventName: "demoViewMode" },
        { title: "Mês", eventName: "demoViewMode" },
      ],
      data: {},
      loading: true,
      showDisplay: true,
      showButtonBack: false,
    };
  },
  computed: { ...mapState("generic", ["event"]) },
  methods: {
    ...mapActions("generic", ["getApi"]),
    ...mapMutations("generic", ["removeLoading"]),
    get(item) {
      let params = {
        url: this.urlGet,
        obj: {
          productId: item?.productId,
          productFullName: item?.productFullName,
          totalStock: item?.totalStock,
        },
      };
      this.getApi(params).then((response) => {
        this.data = response.content;
        let self = this;
        setTimeout(function () {
          self.loading = false;
        }, 500);
        this.removeLoading(["btnPanelReserved"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "timeLineAvailability") {
          this.loading = true;
          this.showButtonBack = event.data.showButtonBack;
          this.get(event.data.item);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
:root {
  --text: #111827;
  --muted: #6b7280;
  --border: #e5e7eb;
  --bg-soft: #fafafa;
}

.timeline-wrap {
  border-radius: 12px;
}

.panel-header {
  background: var(--bg-soft);
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-bottom: 12px;
}

.title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 16px;
  color: var(--text);
  font-weight: 600;
  line-height: 1.3;
}

.title .product {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title .sep {
  color: var(--muted);
  font-weight: 400;
}

.title .muted {
  color: var(--muted);
  font-weight: 500;
}

.title .stock {
  background: #eef2ff;
  border: 1px solid #e0e7ff;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 13px;
  line-height: 18px;
}

.hr {
  border: none;
  height: 1px;
  background: var(--border);
  margin: 12px 0 0;
}

.div-legend {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  padding: 6px 0 12px;
  flex-wrap: wrap;
}

.legend-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--border);
  border-radius: 9999px;
}

.legend-text {
  font-size: 14px;
  color: var(--text);
  font-weight: 400;
}

.box-time {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot-maintenance {
  background-color: #ffc106;
}

.dot-reserved {
  background-color: #018b8b;
}

.dot-rented {
  background-color: #00058b;
}

.align-center {
  display: flex;
  align-items: center;
}

.text-right {
  text-align: right;
}
</style>
